export default __webpack_public_path__ + "static/media/card-m-press@3x.7ffbb925.png";